import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "~/components/ui/pagination";
import { cn } from "~/lib/utils";

interface ClientsPaginationProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  startIndex: number;
  pageSize: number;
  totalClients: number;
}

const ClientsPagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
  startIndex,
  pageSize,
  totalClients,
}: ClientsPaginationProps) => {
  // Generate pagination links
  const getPaginationLinks = () => {
    const links = [];
    const maxLinks = 5;
    const halfLinks = Math.floor(maxLinks / 2);

    let startPage = Math.max(1, currentPage - halfLinks);
    const endPage = Math.min(totalPages, startPage + maxLinks - 1);

    if (endPage - startPage + 1 < maxLinks) {
      startPage = Math.max(1, endPage - maxLinks + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      links.push(
        <PaginationItem key={i}>
          <PaginationLink
            href="#"
            isActive={currentPage === i}
            onClick={(e) => {
              e.preventDefault();
              setCurrentPage(i);
            }}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    return links;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col-reverse items-center justify-between gap-4 py-2 sm:flex-row">
      <div className="w-full text-center text-sm text-muted-foreground sm:w-auto sm:text-left">
        Mostrando {startIndex + 1}-
        {Math.min(startIndex + pageSize, totalClients)} de {totalClients}{" "}
        clientes
      </div>
      <div className="flex w-full justify-center sm:w-auto">
        <Pagination>
          <PaginationContent className="flex flex-wrap justify-center gap-1">
            <PaginationItem>
              <PaginationPrevious
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPage(Math.max(currentPage - 1, 1));
                }}
                className={cn(
                  "h-9 px-2 sm:px-4",
                  currentPage === 1 ? "pointer-events-none opacity-50" : ""
                )}
              />
            </PaginationItem>

            {getPaginationLinks()}

            <PaginationItem>
              <PaginationNext
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentPage(Math.min(currentPage + 1, totalPages));
                }}
                className={cn(
                  "h-9 px-2 sm:px-4",
                  currentPage === totalPages
                    ? "pointer-events-none opacity-50"
                    : ""
                )}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
};

export default ClientsPagination;
